import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import StickyBox from 'react-sticky-box';

import styles from './Sidebar.module.scss';

const Sidebar = ({
  className,
  children,
  beforeHeader,
  isLoading,
  hasActiveFilters,
  handleResetFilters,
}: {
  isLoading?: boolean;
  className?: string;
  children?: ReactNode;
  beforeHeader?: ReactNode;
  hasActiveFilters?: boolean;
  handleResetFilters?: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className={classes([styles.root, className])}>
      <StickyBox offsetTop={0} offsetBottom={0}>
        {beforeHeader}

        {isLoading ? (
          <header className={styles.filtersHead}>
            <Skeleton containerClassName={styles.titleSkeleton} />
            <Skeleton containerClassName={styles.resetSkeleton} />
          </header>
        ) : (
          <header className={styles.filtersHead}>
            <h3>{t('filter')}</h3>
            {hasActiveFilters && (
              <span
                role="button"
                tabIndex={-1}
                className={styles.resetAll}
                onClick={() => handleResetFilters?.()}
              >
                {t('resetAll')}
              </span>
            )}
          </header>
        )}

        {children}
      </StickyBox>
    </div>
  );
};

export default observer(Sidebar);
